import breadcrumbsStore from "./FolderStore";
import navStore from "./projectStore";

export default { navStore, breadcrumbsStore };
